export const LANGUAGE_KEY = 'i18nextLng-v1';
export const REDUX_WALLET_SYNC_KEY = 'cspr-redux-wallet-sync';
export const REDUX_STORAGE_KEY = 'cspr-redux-storage-v1';
export const VIEW_ADDRESS_STORAGE_KEY = 'cspr-view-address';
export const LEDGER_CACHE_STORAGE_KEY = 'cspr-ledger-cache';
export const FAUCET_STORAGE_KEY = 'cspr-faucet';
